import { createApp } from 'vue';
import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css'
import locale from 'element-plus/es/locale/lang/zh-cn'
import '@/assets/styles/base.css'
import '@/assets/styles/demo.css'
import '@/assets/styles/zenburn.css'

import App from './App.vue';
import router from './router';
import store from './store';
// 读取 mark-down-style 中的 css 代码
import 'github-markdown-css/github-markdown.css'
// 读取 highlight.js 代码块样式的 css 
//import 'highlight.js/styles/night-owl.css'
const app = createApp(App);
app.use(ElementPlus, { locale });
app.use(store);
app.use(router);
app.mount('#app');
